// extracted by css-extract-rspack-plugin
export default {"apkLink__downloadButtonContainer":"apkLink__downloadButtonContainer__tL0hR","apkLink__progress":"apkLink__progress__MHRoZ"};